export const EVENT_ENDED = 'ENDED';
export const EVENT_OFF = 'OFF';
export const EVENT_NOT_STARTED = 'NOT_STARTED';
export const EVENT_PENDING = 'PENDING';
export const EVENT_INTERRUPTED = 'INTERRUPTED';
export const EVENT_MANUALLY_DEACTIVATED = 'MANUALLY_DEACTIVATED';
export const EVENT_CANCELED = 'CANCELED';
export const EVENT_RETIRED = 'RETIRED';
export const EVENT_ABANDONED = 'ABANDONED';
export const EVENT_WALKOVER = 'WALKOVER';
export const EVENT_POSTPONED = 'POSTPONED';

/**
 * Checks if the event is over from its match status
 * @param  {String}  eventMatchStatus The event match status
 * @return {Boolean} If the match status matches one of the ended statuses
 */
export function isEventOver(eventMatchStatus = '') {
    return [
        EVENT_ENDED,
        EVENT_INTERRUPTED,
        EVENT_MANUALLY_DEACTIVATED,
        EVENT_CANCELED,
        EVENT_RETIRED,
        EVENT_ABANDONED,
        EVENT_WALKOVER,
        EVENT_OFF,
        EVENT_NOT_STARTED,
        EVENT_PENDING,
    ].includes(eventMatchStatus.toUpperCase());
}
